type ReactText = string | number | (string | number)[];

/**
 * Check if `node` contains only text content. Used to determine whether the
 * `children` of a component should be wrapped.
 */
export function isReactText(node: unknown): node is ReactText {
  // sometimes e.g. `<Comp>{value} content</Comp>` children will be an array,
  // but it's still "text" as far as the consumer is concerned
  if (Array.isArray(node)) {
    return node.every(isReactText);
  }

  return typeof node === 'string' || typeof node === 'number';
}
